module.exports = __webpack_public_path__ + "static/1212263337.2fa7214a.jpg";